$('.js-search-show').on('click', () => {
	TweenMax.to($('.header-form'), 0.75, {
		right: 0,
		onStart() {
			TweenMax.set($('.header-form'), {
				opacity: 1,
				visibility: 'visible',
			});
		},
		onComplete() {
			$('body').addClass('search-open');
		},
	});
});

$('.js-search-close').on('click', () => {
	TweenMax.to($('.header-form'), 0.75, {
		right: '-100%',
		clearProps: 'all',
	});
});

$('body').on('keyup', (e) => {
	if (e.keyCode === 27 && $(e.currentTarget).hasClass('search-open')) {
		TweenMax.to($('.header-form'), 0.75, {
			right: '-100%',
			clearProps: 'all',
			onComplete() {
				$('body').removeClass('search-open');
			},
		});
	}
});
